// extracted by mini-css-extract-plugin
export default {"groupName":"group-module--group-name--R70On"};